export default "__VITE_ASSET__Dr9ovfvY__"